import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      d="M15.884 12.89a.417.417 0 0 1-.563 0L10 7.9l-5.32 4.99a.417.417 0 0 1-.563 0 .357.357 0 0 1 0-.527L9.719 7.11A.4.4 0 0 1 10 7c.105 0 .207.04.281.11l5.602 5.253a.357.357 0 0 1 0 .528"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronUp;
